import { AjaxError } from 'rxjs/ajax';
import { FailureActionPayload } from 'store/errors/types';
import { PaymentError } from 'shared/consts';

const mapErrorCode = (error: Error): number => {
  if (error instanceof AjaxError) {
    return error.response?.data?.code ?? error.response?.errorCode;
  }

  return undefined;
};

export const mapHttpStatusCode = (errorCode: string | number | undefined): number => {
  return typeof errorCode === 'string' ? parseInt(errorCode, 10) : errorCode;
};

export const toSerializableError = (
  error: SerializableError | PaymentError | FailureActionPayload,
): SerializableError => {
  if ('response' in error && error.response) {
    let statusCode: number | undefined;

    if ('statusCode' in error.response) {
      const { statusCode: responseStatusCode } = error.response;

      statusCode = mapHttpStatusCode(responseStatusCode);
    } else if ('status' in error) {
      statusCode = mapHttpStatusCode(error.status);
    } else if ('data' in error.response) {
      statusCode = mapErrorCode(error);
    }

    return {
      ...error,
      response: {
        ...error.response,
        statusCode,
      },
    };
  }
  return error as SerializableError;
};
